<template>
  <div class="success-img">
    <div class="circle">
      <img src="@/assets/circle.svg" />
    </div>
    <div class="tick">
      <img src="@/assets/tick.svg" />
    </div>
  </div>
</template>

<script>
  export default {
    mounted() {
      //console.log('New component mounted.')
    }
  }
</script>

<style lang="scss" scoped>
.success-img {
  position: relative;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 1;
  left: 50px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-delay: 0.5s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards; 
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 57px;
  width: 45px;
  height: 45px;
  opacity: 1;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-delay: 0.5s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards; 
}
@keyframes showc {
  0% {opacity: 0; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showt {
  0% { opacity: 0; transform: scale(0.2);}
  80% { transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}
</style>
